module.exports = __webpack_public_path__ + "img/erp_service3.1241e5d4.png";